<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
<!-- Breadcrumb y ayuda -->    
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container" v-if="p_pagina=='R'">
            <router-link to="/referencia">Referencias</router-link>
            > Referencia {{ datoReferencia.idReferencia }}			
          </div>
          <div class="breadcrumb-container" v-if="p_pagina=='A'">
            <router-link to="/atencion">Atenciones</router-link> >
            <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_numeroAtencion }}</router-link> >
            <router-link :to="'/atencion_referencia/' + p_idAtencion + '/' + p_estadoAtencion + '/' + p_numeroAtencion">Referencias - Derivaciones</router-link>
            > {{ p_idReferencia }}
          </div>		  
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">help
          </span>
        </div>
      </div>
    </div>
    <hr>
<!-- Modal -->
      <form>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">

  <div class="modal-body form-card">
    <div class="mb-3" v-if="btnEditar">
      <div class="row">
        <div class="col-3">
          <label for="idReferencia" class="form-label">ID de Referencia</label>
        </div>
        <div class="col-9">
          <span id="idReferencia" class="form-control-plaintext">{{ datoReferencia.idReferencia }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="pacienteNombre" class="form-label">Nombre del Paciente</label>
        </div>
        <div class="col-9">
          <span id="pacienteNombre" class="form-control-plaintext">{{ datoReferencia.pacienteNombre }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="motivoRefNombre" class="form-label">Motivo de Referencia</label>
        </div>
        <div class="col-9">
          <span id="motivoRefNombre" class="form-control-plaintext">{{ datoReferencia.motivoRefNombre }}</span>
        </div>
      </div>
    </div>

  </div>
  </div>
  </div>

  <div class="modal-dialog modal-xl">
    <div class="modal-content">

  <div class="modal-body form-card">

    <button @click.prevent="mostrarOcultarBloque">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
      <div v-if="mostrarBloque" class="mb-3">

        <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="empresaOrigen" class="form-label">Empresa de Origen</label>
        </div>
        <div class="col-9">
          <span id="empresaOrigen" class="form-control-plaintext">{{ datoReferencia.empresaOrigen }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="empresaDestino" class="form-label">Empresa de Destino</label>
        </div>
        <div class="col-9">
          <span id="empresaDestino" class="form-control-plaintext">{{ datoReferencia.empresaDestino }}</span>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="medicoNombre" class="form-label">Nombre del Médico</label>
        </div>
        <div class="col-9">
          <span id="medicoNombre" class="form-control-plaintext">{{ datoReferencia.medicoNombre }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="fechaReg" class="form-label">Fecha de Registro</label>
        </div>
        <div class="col-9">
          <span id="fechaReg" class="form-control-plaintext">{{ datoReferencia.fechaReg }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="fechaRef" class="form-label">Fecha de Referencia</label>
        </div>
        <div class="col-9">
          <span id="fechaRef" class="form-control-plaintext">{{ datoReferencia.fechaRef }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="hora" class="form-label">Hora</label>
        </div>
        <div class="col-9">
          <span id="hora" class="form-control-plaintext" style="text-transform:uppercase">{{ datoReferencia.hora }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="tipo" class="form-label">Tipo</label>
        </div>
        <div class="col-9">
          <span id="tipo" class="form-control-plaintext" style="text-transform:uppercase">{{ datoReferencia.tipo }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="motivo" class="form-label">Motivo</label>
        </div>
        <div class="col-9">
          <span id="motivo" class="form-control-plaintext" style="text-transform:uppercase">{{ datoReferencia.motivo }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="resumen" class="form-label">Resumen</label>
        </div>
        <div class="col-9">
          <span id="resumen" class="form-control-plaintext" style="text-transform:uppercase">{{ datoReferencia.resumen }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="hallazgos" class="form-label">Hallazgos</label>
        </div>
        <div class="col-9">
          <span id="hallazgos" class="form-control-plaintext" style="text-transform:uppercase">{{ datoReferencia.hallazgos }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="tratamiento" class="form-label">Tratamiento</label>
        </div>
        <div class="col-9">
          <span id="tratamiento" class="form-control-plaintext" style="text-transform:uppercase">{{ datoReferencia.tratamiento }}</span>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-3">
          <label for="justificada" class="form-label">Justificación</label>
        </div>
        <div class="col-9">
          <span id="justificada" class="form-control-plaintext" style="text-transform:uppercase">{{ datoReferencia.justificada }}</span>
        </div>
      </div>
    </div>

  </div>
</div>  

    </div>
  </div>
</form>

    <!-- Estructura de Tabs -->
    <div class="tabs">
      <button class="tablink" @click="showTable = 'referenciaDet'" :class="{ 'active-tab': showTable === 'referenciaDet' }">
        Diagnósticos
      </button>
    </div>

    <!-- Contenido dinámico según la pestaña seleccionada -->
    <div v-if="showTable === 'referenciaDet'">
      <ReferenciaDet :p_idAtencion="p_idAtencion"
                     :p_numeroAtencion="p_numeroAtencion"
                     :p_idReferencia="datoReferencia.idReferencia"
                     :p_estadoAtencion="p_estadoAtencion" 
      ></ReferenciaDet>
    </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-md-4">
        </div>
        <div class="col-md-4">

          <Modal v-model:modelValue="showModalDocumento">
            <DocVerFirmarGuardar :idReporte="7"
                                :idDocumento="datoReferencia.idReferencia"/>
          </Modal>
          <button type="button"
                  class="btn btn-light"
                  @click="showModalDocumento = true"
                  title="Formulario 053 - Referencia-Derivación">
            <span class="material-symbols-outlined" style="font-size:32px;color:green; cursor: pointer;">
              quick_reference_all
            </span>
            Formulario 053 - Referencia-Derivación
          </button>
        </div>

        <div class="col-md-4">
        </div>
      </div>
    </div>
    
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import DocVerFirmarGuardar from '../utils/DocVerFirmarGuardar.vue';
import ReferenciaDet from '../forms/ReferenciaDet.vue';
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  props: {
    p_idAtencion:     { type: Number, required: true },
    p_numeroAtencion: { type: String, required: true },
    p_idReferencia:   { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_pagina:         { type: String, required: true },
  },
  components : {
    Layout, Footer, ReferenciaDet, DocVerFirmarGuardar
  },
  data () {
    return {
      referencias : [],
      datoReferencia : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      atencions: [],
      motivoRefs: [],
      empresaOrigens: [],
      empresaDestinos: [],
      personas: [],
      medicos: [],
      mostrarBloque: false,
      showTable: 'referenciaDet', // Pestaña por defecto
      showModalHelp: false,
      showModalDocumento: false,
    }
  },
  mounted () {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.getData()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
   getData() {
      api.get('/vwreferencias/'+this.p_idReferencia)
        .then(response => {
          this.datoReferencia = response.data;
        })
        .catch(error => {
         console.error('Error al obtener datos de la persona:', error);
        });
    },
    async guardarReferencia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/referencias', this.datoReferencia)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Referencia creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
  },
}
</script>
<style src="@/assets/css/tabs.css" scoped></style>
<style scoped>
  .modal-body label {
    font-weight: bold;
  }
</style>
